import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { className, rows = 4, ...textareaProps },
  forwardedRef
) {
  return (
    <textarea
      ref={forwardedRef}
      rows={rows}
      className={cn(
        'w-full min-h-[6rem] px-4 py-2.5 bg-zoooffwhite border border-zooborder rounded-xl text-zooindigo transition-all resize-y placeholder:text-zoomuted focus:outline-none focus:border-zooprimary focus:ring-2 focus:ring-zooprimary/40 disabled:bg-zoodisabledbg disabled:text-zoodisabledtext',
        className
      )}
      {...textareaProps}
    />
  );
});
